module.exports = __webpack_public_path__ + "static/media/HindVadodara-Medium.f08006e2.woff";